export const ActivationCodeConfiguration = {
    ACTIVATION_ATTEMPTS : parseInt(process.env.REACT_APP_ACTIVATION_ATTEMPTS ?? "6")
}